import {GET_BASE_URL} from "../constants";
import { userFacingMutationMessage } from "./loungeSession";
import { buildLoungeAuthHeaders } from "./loungeAuthHeader";

type UploadImageResult = { status: number; data: { c_file_name: string } };

const UPLOAD_FAILED_MESSAGE = 'Sorry, that photo could not be added. Please try again.';

/**
 * Uploads a photo for the post/comment editors. The backend requires a
 * signed-in member and only accepts real JPG/PNG/GIF/WebP files; when it
 * refuses, the member sees its reason and the editor inserts nothing.
 *
 * `/api/v1/uploadImage` has no park parameter and stores files under
 * `/disneyland/chat_images` for both Disneyland and WDW editor inserts.
 * WDW post attachments (`{chat_id}_c_img.jpg` via replaceImageWdw / compose)
 * are a different path and live under `/disneyworld/chat_images`.
 */
export const UploadImage = async (file: File): Promise<UploadImageResult> => {
    const formData = new FormData();
    formData.append('upload_img', file);

    const token = localStorage.getItem('token');
    let result: any = null;
    try {
        const response = await fetch(GET_BASE_URL + '/api/v1/uploadImage', {
            method: 'POST',
            headers: token ? buildLoungeAuthHeaders(token) : undefined,
            body: formData,
        });
        result = await response.json().catch(() => null);
        if (response.ok && result?.data?.c_file_name) {
            return result;
        }
    } catch {
        // Network failure: fall through to the generic message.
    }

    const message = userFacingMutationMessage(result, UPLOAD_FAILED_MESSAGE);
    if (message) {
      window.alert(message);
      throw new Error(message);
    }
    throw new Error(UPLOAD_FAILED_MESSAGE);
};
